import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Córdoba'
}, {
  name: 'Julián L.',
  location: 'Buenos Aires'
}, {
  name: 'Carolina P.',
  location: 'La Plata'
}, {
  name: 'Ricardo A.',
  location: 'Mendoza'
}, {
  name: 'Florencia B.',
  location: 'Rosario'
}, {
  name: 'Agustina S.',
  location: 'CABA'
}];
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const buyer = buyers[buyerIndex];
  useEffect(() => {
    const openTimer = window.setTimeout(() => setIsVisible(true), 4500);
    const interval = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setBuyerIndex(current => (current + 1) % buyers.length);
        setIsVisible(true);
      }, 800);
    }, 30000);
    return () => {
      window.clearTimeout(openTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-91" data-mp="1vybu7of9dh9q">
      {isVisible && <motion.aside initial={reduceMotion ? false : {
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? undefined : {
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] md:bottom-7 md:left-7" data-id="element-92" data-mp="1vv7kkbj0xtbo">
          <div className="glass-panel flex gap-3 rounded-2xl border-brand-purple/25 bg-brand-paper/95 p-4 shadow-xl" data-id="element-93" data-mp="1d4g5ctccv8pd">
            <span className="mt-0.5 rounded-full bg-brand-purple/10 p-2" data-id="element-94" data-mp="138cyja6k6lw3"><BadgeCheckIcon className="h-5 w-5 text-brand-purple" data-id="element-95" data-mp="13a69v2s49uaf" /></span>
            <div data-id="element-96" data-mp="z5q5j5y5iuxb">
              <p className="text-xs text-brand-muted" data-id="element-97" data-mp="z68cawifwrjh">Compra verificada · hace unos minutos</p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-98" data-mp="u86sg9d6wo6y"><strong data-id="element-99" data-mp="kk2jtgcavicc">{buyer.name}</strong> de {buyer.location} compró</p>
              <p className="mt-1 text-sm font-bold text-brand-purple" data-id="element-100" data-mp="km5jks398pu9">MEGA PACK REIKI™</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}